import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BilibiliFilledSvg from "@ant-design/icons-svg/es/asn/BilibiliFilled";
import AntdIcon from '../components/AntdIcon';
var BilibiliFilled = function BilibiliFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: BilibiliFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(BilibiliFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'BilibiliFilled';
}
export default RefIcon;